import Actions, { types } from './actions';
import { AppBarType } from '.';

const initialState: AppBarType = {
  photoPath: "",
  collapsedSidebar: false,
  loginUser : null
};

const reducer = (state = initialState, action: Actions): AppBarType => {
  const newState = { ...state };
  switch (action.type) {
    case types.CHANGE_AVATAR:
      newState.photoPath = action.payload;
      return newState;
    case types.TOGGLE_COLLAPSED_SIDEBAR:
      newState.collapsedSidebar = !state.collapsedSidebar;
      return newState;
    case types.SET_LOGIN_USER: 
      newState.loginUser = action.payload
      return newState;
    default:
      return state;
  }
};

export default reducer;
